import React, { useEffect, useState } from "react";

import api from "../../../api";
import Banner from "./include/Banner";

const API_URL = `${process.env.REACT_APP_API_URL}/api/research/cdct`;

const ResearchCDCT = () => {
  const [cdctData, setCdctData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(API_URL);
        setCdctData(response.data.cdct.content);
      } catch (err) {
        console.error("Error fetching CDCT data:", err);
        setError("Failed to load CDCT data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <div className="container mt-5 text-center">Loading CDCT details...</div>;
  }

  if (error || !cdctData) {
    return (
      <div className="container mt-5 text-center text-danger">
        {error || "CDCT data not available."}
      </div>
    );
  }

  const {
    images,
    main_heading,
    sub_heading,
    intro_paragraphs,
    key_functions,
    team_members,
    other_staff,
    structure_list,
    structure_statement,
    divisions,
  } = cdctData;

  // Split structure list into two equal columns
  const half = Math.ceil(structure_list.length / 2);
  const structureLeft = structure_list.slice(0, half);
  const structureRight = structure_list.slice(half);

  return (
    <>
      {/* Dynamic Banner */}
      <Banner bannerImages={images} heading={main_heading} />

      <section className="research_cdct_section">
        <div className="container ">
          <div className="row mb-2 mb-md-5">
            <div className="col-md-12">
              <div className="res-content">

                {/* Headings */}
                  <div className="sec-title text-center py-4"><h2>{main_heading}</h2></div>
              <div className=" text-center py-0 py-md-2"><h2 >{sub_heading}</h2></div>
             

                {/* Intro paragraphs */}
                {intro_paragraphs.map((p, i) => (
                  <p key={i} >
                    {p}
                  </p>
                ))}

                {/* Key Functions */}
                <p >The key functions of CDCT are:</p>
                <ul className="list-circle">
                  {key_functions.map((item, index) => (
                    <li key={index} >
                      <i className="fa fa-check-circle-o me-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>

                {/* Team Section */}
                <div className="sec-title text-center py-4"><h2>Team</h2></div>
          
                <p >
                  All the members of CDCT are well trained in Good Clinical Practice and other relevant regulatory guidelines.
                </p>

                {/* Team Table */}
                <div className="table-responsive mb-3" >
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>S. No.</th>
                        <th>Members</th>
                        <th>Name</th>
                        <th>Designation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {team_members.map((member, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="fw-bold">{member.role}</td>
                          <td>{member.name}</td>
                          <td>{member.designation}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Other Staff */}
                <h2 className="mt-4 mb-4">Other staff:</h2>
                <div className="row mb-2 mb-md-5">
                  <div className="col-md-6">
                    <ul className="list-circle list-unstyled">
                      {other_staff.slice(0, 4).map((staff, i) => (
                        <li key={i}>
                          <i className="fa fa-check-circle-o me-2"></i>{staff}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-circle list-unstyled">
                      {other_staff.slice(4).map((staff, i) => (
                        <li key={i}>
                          <i className="fa fa-check-circle-o me-2"></i>{staff}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Structure Section */}
                  <div className="sec-title text-center py-4"><h2>Structure</h2></div>

                <h2 className="mt-2 mb-2">{structure_statement}</h2>

                <div className="row mb-2 mb-md-5">
                  <div className="col-md-6">
                    <ul className="list-circle">
                      {structureLeft.map((item, i) => (
                        <li key={i}>
                          <i className="fa fa-check-circle-o me-2"></i>{item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-circle">
                      {structureRight.map((item, i) => (
                        <li key={i}>
                          <i className="fa fa-check-circle-o me-2"></i>{item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Divisions Section */}
                  <div className="sec-title text-center py-4"><h2>Divisions</h2></div>
         

                <div className="accordion" id="divisionAccordion">
                  {divisions.map((div, i) => (
                    <div className="accordion-item" key={i}>
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#${div.collapse_id}`}
                        >
                          {div.title}
                        </button>
                      </h2>
                      <div
                        id={div.collapse_id}
                        className="accordion-collapse collapse"
                        data-bs-parent="#divisionAccordion"
                      >
                        <div className="accordion-body">
                           <h2 className="mt-2 mb-2 text-start">
                              Lead - {div.lead_name}, {div.lead_designation}
                           </h2>
                          <div dangerouslySetInnerHTML={{ __html: div.content }} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* End Divisions */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchCDCT;
